<template>
  <v-ons-page class="l-content l-document">
    <custom-toolbar backLabel="Retour">{{ $t("Brochures") }}</custom-toolbar>

    <v-ons-list>
      <v-ons-list-item v-for="(brochure, index) in brochures" :key="index" @click="view(brochure)" tappable>
        <div class="center">{{ brochure.title }}</div>
        <div class="right">
          <v-ons-button>
            <i class="fas fa-eye"></i>
          </v-ons-button>
        </div>
      </v-ons-list-item>
    </v-ons-list>
  </v-ons-page>
</template>

<script>
import { EventBus } from '../EventBus.js';

export default {
  methods: {
    view(brochure) {
      // window.open(url_erp + '/app_customers/' + brochure.path, '_blank', 'location=no,enableViewportScale=yes');
      window.open('https://docs.google.com/viewer?url=' + url_erp + '/app_customers/' + brochure.path + '&embedded=true', '_blank', 'location=no');
    }
  },
  computed: {
    brochures() {
      return this.keyholding.brochures[this.$i18n.locale];
    }
  }
};
</script>


// WEBPACK FOOTER //
// KeyholdingBrochures.vue?4de4126e